const isValidFlight = flight => {
  return (
    flight.departure != null &&
    flight.arrival != null &&
    flight.departure.datetime != null &&
    flight.departure.name != null &&
    flight.arrival.datetime != null &&
    flight.arrival.name != null
  );
};

export default isValidFlight;
